<template>
    <div style="width: 100%">
        <v-card elevation="0">
            <div class="d-flex align-center mr-4">
                <v-card-title
                    class="d-flex grow justify-start"
                    v-if="$vuetify.breakpoint.mdAndUp"
                >
                    <h3 class="ma-0 font-weight-light">Seguimiento Ofertas</h3>
                </v-card-title>

                <v-tabs
                    v-model="actualTab"
                    color="primary"
                    class="d-flex justify-end"
                >
                    <v-tab
                        v-for="estado in humanEstado"
                        :key="estado"
                        :disabled="loading"
                    >
                        {{ estado }}
                    </v-tab>
                </v-tabs>
            </div>
            <v-tabs-items v-model="actualTab">
                <v-tab-item v-for="estado in encodedEstado" :key="estado">
                    <!-- <v-divider class="test mb-2"></v-divider> -->
                    <v-card elevation="0">
                        <TablaVentas
                            :filterOffers="filterOffers(estado)"
                            :showChangeState="actualTab"
                            :estado="estado"
                            @offerEmit="onClickChild($event)"
                        />
                    </v-card>
                </v-tab-item>
            </v-tabs-items>
        </v-card>
        <PDFView :offer="offer" />
        <OrdersView
            :packages="packages ? packages.packages : null"
            :updatedOn="packages ? packages.updatedOn : null"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import TablaVentas from './TablaVentas.vue';
import PDFView from '@/components/PDFView/PDFView.vue';
import OrdersView from '@/components/ComercialTeletrabajo/DetailedView/OrdersView.vue';

export default {
    name: 'RegistroVentas',
    components: {
        TablaVentas,
        PDFView,
        OrdersView,
    },
    data: () => ({
        tab: 1,
        offer: null,
        packages: null,
    }),
    props: {
        currentDate: Date,
    },
    computed: {
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        // ...mapState('util', {
        //     opciones: (state) => state.opciones,
        // }),
        ...mapState('areaPersonal/calculadora', {
            loading: (state) => state.isLoadingOfertas,
        }),
        actualTab: {
            get() {
                return this.$store.state.areaPersonal.calculadora.actualTab;
            },
            set(value) {
                this.$store.commit('areaPersonal/calculadora/actualTab', value);
            },
        },
        humanEstado() {
            let estados = [];

            if (this.opciones) {
                estados = this.opciones.oferta.estado.map(({ human }) => human);
                estados.pop();
            }

            return estados;
        },
        encodedEstado() {
            let estados = [];

            if (this.opciones) {
                estados = this.opciones.oferta.estado.map(
                    ({ encoded }) => encoded
                );
                estados.pop();
            }

            return estados;
        },
    },
    methods: {
        onClickChild({ nameComponent, data }) {
            if (nameComponent === 'PDFView') {
                this.offer = JSON.parse(JSON.stringify(data));
                let PDFView = {
                    isLoadingHtmlOffer: true,
                    isOpenViewDialog: true,
                    ofertaHtml: '',
                };

                this.$store.commit('util/PDFView', PDFView);
            } else if (nameComponent === 'OrdersView') {
                this.packages = JSON.parse(JSON.stringify(data));
            }
        },
        filterOffers(estado) {
            return {
                estado: estado,
                mes_year_updated_on: `${this.currentDate.getFullYear()}-${
                    this.currentDate.getMonth() + 1
                }`,
            };
        },
    },
};
</script>

<style>
</style>